import { render, staticRenderFns } from "./ListReportSettings.vue?vue&type=template&id=1b2d05fe"
import script from "./ListReportSettings.vue?vue&type=script&lang=js"
export * from "./ListReportSettings.vue?vue&type=script&lang=js"
import style0 from "./ListReportSettings.vue?vue&type=style&index=0&id=1b2d05fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports